import React, { useState, useEffect } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { Modal } from '@mui/material'

import '../styles/cocktailDetails.scss'
import axios from 'axios'

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditIcon from '@mui/icons-material/Edit'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import backButton from '../images/backButton.png'
import cocktailImg from '../images/cocktail.webp'
import AddCocktail from '../components/AddCocktail'
import { toast } from 'react-toastify'

const CocktailDetails = () => {
  const [image, setImage] = useState(null)
  const [cocktail, setCocktail] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [EditModal, setEditModal] = useState(false)

  const { id } = useParams()
  const navigate = useNavigate()

  const connected = sessionStorage.getItem('profil')

  useEffect(() => {
    if (cocktail) {
      setImage(
        `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/static/${cocktail.imageFileName}`
      )
    }
  }, [cocktail])

  useEffect(() => {
    axios({
      method: 'get',
      url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/cocktails/id/${id}`,
      headers: { Authorization: sessionStorage.getItem('token') },
    })
      .then((res) => {
        setCocktail(res.data)
      })
      .catch((error) => {
        switch (error.response.status) {
          case 401:
            toast.error('veuillez vous connecter')
            sessionStorage.clear()
            break
          case 404:
            toast.error("Le cocktail n'existe pas")
            navigate('/')
            break

          default:
            console.error(error)
            toast.error(error.message)
            break
        }
      })
  }, [])

  const handleDelete = () => {
    axios({
      method: 'delete',
      url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/cocktails/${id}`,
      headers: { Authorization: sessionStorage.getItem('token') },
    })
      .then(() => {
        navigate(`/`)
        toast.success('Le cocktail a été supprimé avec succès')
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('veuillez vous connecter')
          sessionStorage.clear()
        } else {
          console.error(error)
          toast.error(error.message)
        }
      })
  }

  return (
    <>
      {cocktail && (
        <div className="cocktail-details">
          <Modal
            open={deleteModal}
            onClose={() => setDeleteModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="box-modal-delete-cocktail">
              <h2>Voulez-vous supprimer {cocktail.name} ?</h2>
              <div className="buttons">
                <Button
                  variant="contained"
                  onClick={() => setDeleteModal(false)}
                >
                  Annuler
                </Button>
                <Button variant="contained" onClick={() => handleDelete()}>
                  Confirmer
                </Button>
              </div>
            </Box>
          </Modal>

          <Link className="back-button" to={'/'}>
            <img src={backButton} alt="backButton" />
          </Link>

          <>
            <div className="cocktail-image">
              <img
                src={image}
                alt="cocktail"
                onError={(e) => {
                  e.target.src = cocktailImg
                }}
              />
            </div>
            <div className="description">
              <h1>{cocktail.name}</h1>
              <ul>
                {cocktail.ingredients.map((ingredient, index) => (
                  <li key={index}>{ingredient}</li>
                ))}
              </ul>
              <p>{cocktail.description}</p>
            </div>
            {connected ? (
              <footer>
                <button className="icon" onClick={() => setDeleteModal(true)}>
                  <DeleteOutlineOutlinedIcon fontSize="large" />
                </button>
                <button className="icon" onClick={() => setEditModal(true)}>
                  <EditIcon fontSize="large" />
                  <AddCocktail
                    modal={EditModal}
                    setModal={setEditModal}
                    cocktail={cocktail}
                    setCocktail={setCocktail}
                  />
                </button>
              </footer>
            ) : (
              <></>
            )}
          </>
        </div>
      )}
    </>
  )
}

export default CocktailDetails
